import { AppointmentListItem } from '@spike/appointments-list-model';

export interface KanbanUnitGroup {
    key: string;
    unitId: number;
    title: string;
    appointments: Array<AppointmentListItem>;
}

export interface KanbanRoomColumn {
    key: string;
    roomId: number | null;
    title: string;
    units: Array<KanbanUnitGroup>;
    appointments: Array<AppointmentListItem>;
    locationName?: string;
}

const byStartAt = (a: AppointmentListItem, b: AppointmentListItem) => a.startAt.valueOf() - b.startAt.valueOf();

export const groupDaycareAppointments = (appointments: Array<AppointmentListItem>): Array<KanbanRoomColumn> => {
    const unassigned = appointments.filter(app => app.room?.unit?.id == null).sort(byStartAt);

    const byRoomId = new Map<number, Array<AppointmentListItem>>();
    appointments.forEach(app => {
        const roomId = app.room?.id;
        const unitId = app.room?.unit?.id;
        if (roomId == null || unitId == null) {
            return;
        }
        const group = byRoomId.get(roomId) ?? [];
        group.push(app);
        byRoomId.set(roomId, group);
    });

    const roomColumns = Array.from(byRoomId.entries())
        .map(([roomId, roomAppointments]) => {
            const byUnitId = new Map<number, KanbanUnitGroup>();
            roomAppointments.forEach(app => {
                const unitId = app.room!.unit.id;
                const unit = byUnitId.get(unitId) ?? {
                    key: `unit-${unitId}`,
                    unitId,
                    title: app.room!.unit.name,
                    appointments: []
                };
                unit.appointments.push(app);
                byUnitId.set(unitId, unit);
            });

            const units = Array.from(byUnitId.values())
                .map(unit => ({ ...unit, appointments: unit.appointments.sort(byStartAt) }))
                .sort((a, b) => a.title.localeCompare(b.title));

            return {
                key: `room-${roomId}`,
                roomId,
                title: roomAppointments[0].room?.name ?? 'Room',
                units,
                appointments: roomAppointments.sort(byStartAt)
            };
        })
        .sort((a, b) => a.title.localeCompare(b.title));

    return [
        {
            key: 'unassigned',
            roomId: null,
            title: 'Unassigned',
            units: [],
            appointments: unassigned
        },
        ...roomColumns
    ];
};
